/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {Acl} from "../model/acl";
import {AclAdmin} from "../model/acl-admin";
import {ActivateUserRequest} from "../model/activate-user-request";
import {BatchUpdateUserRequest} from "../model/batch-update-user-request";
import {ChangePasswordRequest} from "../model/change-password-request";
import {CreateAdHocUserRequest} from "../model/create-ad-hoc-user-request";
import {CreateUserRequest} from "../model/create-user-request";
import {DataAclAdmin} from "../model/data-acl-admin";
import {DeactivateUserRequest} from "../model/deactivate-user-request";
import {DeleteUserRequest} from "../model/delete-user-request";
import {DeviceActivityType} from "../model/device-activity-type";
import {GetCurrentUserResponse} from "../model/get-current-user-response";
import {GetUserByIdsRequest} from "../model/get-user-by-ids-request";
import {ImportUsersConfigRequest} from "../model/import-users-config-request";
import {ImportUsersResponse} from "../model/import-users-response";
import {ListData} from "../model/list-data";
import {LockRequest} from "../model/lock-request";
import {LoginRequest} from "../model/login-request";
import {PasswordResetCode} from "../model/password-reset-code";
import {ReplaceAclRequest} from "../model/replace-acl-request";
import {ResetPasswordByTokenRequest} from "../model/reset-password-by-token-request";
import {SaveAclRequest} from "../model/save-acl-request";
import {SaveDataAclResponse} from "../model/save-data-acl-response";
import {SearchParamRequest} from "../model/search-param-request";
import {SendPasswordResetLinkRequest} from "../model/send-password-reset-link-request";
import {SetActivatePeriodBatchRequest} from "../model/set-activate-period-batch-request";
import {SimUser} from "../model/sim-user";
import {SuccessResponse} from "../model/success-response";
import {UnlockRequest} from "../model/unlock-request";
import {UpdateUserRequest} from "../model/update-user-request";
import {UploadFileRequest} from "../model/upload-file-request";
import {UserResponse} from "../model/user-response";

@Injectable({
    providedIn: "root",
})
export class SimUserService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public activateUser(request: ActivateUserRequest) {
        return super.post<boolean>(`/api/User/ActivateUser`, request);
    }

    public autoLogin() {
        return super.post<DeviceActivityType>(`/api/User/AutoLogin`, {});
    }

    public changePassword(request: ChangePasswordRequest) {
        return super.post<SuccessResponse>(`/api/User/ChangePassword`, request);
    }

    public createAdHocUser(request: CreateAdHocUserRequest) {
        return super.post<UserResponse>(`/api/User/CreateAdHocUser`, request);
    }

    public createUser(createUserRequest: CreateUserRequest) {
        return super.post<UserResponse>(`/api/User/CreateUser`, createUserRequest);
    }

    public deactivateUser(request: DeactivateUserRequest) {
        return super.post<boolean>(`/api/User/DeactivateUser`, request);
    }

    public deleteBatch(request: BatchUpdateUserRequest) {
        return super.post<SuccessResponse>(`/api/User/DeleteBatch`, request);
    }

    public deleteUser(request: DeleteUserRequest) {
        return super.post<SuccessResponse>(`/api/User/DeleteUser`, request);
    }

    public exportUserAcl_Url() {
        return super.getUrl(`/api/User/ExportUserAcl`, );
    }

    public exportUserAclExcel_Url() {
        return super.getUrl(`/api/User/ExportUserAclExcel`, );
    }

    public exportUserDataAcl_Url() {
        return super.getUrl(`/api/User/ExportUserDataAcl`, );
    }

    public fetchFilteredLocalUsers(searchParameters: SearchParamRequest) {
        return super.get<ListData<SimUser>>(`/api/User/FetchFilteredLocalUsers`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getCurrentUser() {
        return super.get<GetCurrentUserResponse>(`/api/User/GetCurrentUser`, );
    }

    public getDefaultAcl() {
        return super.get<Acl>(`/api/User/GetDefaultAcl`, );
    }

    public getUserById(userId: string) {
        return super.get<SimUser>(`/api/User/GetUserById`, {userId: userId});
    }

    public getUsersByIds(request: GetUserByIdsRequest) {
        return super.post<SimUser[]>(`/api/User/GetUsersByIds`, request);
    }
/**
 * Imports users from an Excel file.
 */ 

    public importUsersFromExcelAsync(usersConfig: ImportUsersConfigRequest) {
        let formData = this.createFormData(usersConfig);
		return super.upload<ImportUsersResponse>(`/api/User/ImportUsersFromExcel`, formData, {}, [], "events", true);
    }

    public listAcl() {
        return super.get<AclAdmin>(`/api/User/ListAcl`, );
    }

    public listDataAcl() {
        return super.get<DataAclAdmin>(`/api/User/ListDataAcl`, );
    }

    public listUsers(searchTerm: string = null, sortColumn: string = "Lastname", sortAscending: boolean = false, page: number = 0, pageSize: number = 2147483647, onlyLocal: boolean = false, includeSystemUsers: boolean = false, includeInactiveUsers: boolean = true) {
        return super.get<ListData<SimUser>>(`/api/User/ListUsers`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize, onlyLocal: onlyLocal, includeSystemUsers: includeSystemUsers, includeInactiveUsers: includeInactiveUsers});
    }

    public lockUser(request: LockRequest) {
        return super.post<boolean>(`/api/User/LockUser`, request);
    }

    public login(request: LoginRequest) {
        return super.post<boolean>(`/api/User/Login`, request);
    }

    public loginAsGuest() {
        return super.post<boolean>(`/api/User/LoginAsGuest`, {});
    }

    public loginForPWChange(request: LoginRequest) {
        return super.post<boolean>(`/api/User/LoginForPWChange`, request);
    }

    public logout() {
        return super.post<void>(`/api/User/Logout`, {});
    }

    public replaceAcl(request: ReplaceAclRequest) {
        return super.post<SuccessResponse>(`/api/User/ReplaceAcl`, request);
    }

    public resetPasswordByToken(request: ResetPasswordByTokenRequest) {
        return super.post<PasswordResetCode>(`/api/User/ResetPasswordByToken`, request);
    }

    public saveAcl(request: SaveAclRequest) {
        return super.post<SuccessResponse>(`/api/User/SaveAcl`, request);
    }

    public saveDataAcl(permissionList: DataAclAdmin) {
        return super.post<SaveDataAclResponse>(`/api/User/SaveDataAcl`, permissionList);
    }

    public sendPasswordResetLink(request: SendPasswordResetLinkRequest) {
        return super.post<PasswordResetCode>(`/api/User/SendPasswordResetLink`, request);
    }

    public setActivatePeriodBatch(request: SetActivatePeriodBatchRequest) {
        return super.post<boolean>(`/api/User/SetActivatePeriodBatch`, request);
    }

    public unlockUser(request: UnlockRequest) {
        return super.post<boolean>(`/api/User/UnlockUser`, request);
    }

    public updateUser(request: UpdateUserRequest) {
        return super.post<UserResponse>(`/api/User/UpdateUser`, request);
    }

    public uploadUserAcl(uploadUserAcl: UploadFileRequest) {
        let formData = this.createFormData(uploadUserAcl);
		return super.upload<void>(`/api/User/UploadUserAcl`, formData, {}, [], "events", true);
    }

    public uploadUserAclExcel(uploadUserAcl: UploadFileRequest) {
        let formData = this.createFormData(uploadUserAcl);
		return super.upload<void>(`/api/User/UploadUserAclExcel`, formData, {}, [], "events", true);
    }

    public uploadUserDataAcl(uploadUserDataAcl: UploadFileRequest) {
        let formData = this.createFormData(uploadUserDataAcl);
		return super.upload<void>(`/api/User/UploadUserDataAcl`, formData, {}, [], "events", true);
    }
}